import {View} from 'react-native'
import {Trans} from '@lingui/macro'

import {FEED_FALLBACK_FEED, FEED_FALLBACK_FEEDNAME} from '#/lib/constants'
import {usePalette} from '#/lib/hooks/usePalette'
import {InfoCircleIcon} from '#/lib/icons'
import {TextLink} from '../util/Link'
import {Text} from '../util/text/Text'

export function DiscoverFallbackHeader() {
  const pal = usePalette('default')
  return (
    <View
      style={[
        {
          flexDirection: 'row',
          alignItems: 'center',
          paddingVertical: 12,
          paddingHorizontal: 12,
          borderTopWidth: 1,
        },
        pal.border,
        pal.viewLight,
      ]}>
      <View style={{width: 68, paddingLeft: 12}}>
        <InfoCircleIcon size={36} style={pal.textLight} strokeWidth={1.5} />
      </View>
      {FEED_FALLBACK_FEED ? (
        <View style={{flex: 1}}>
          <Text type="md" style={pal.text}>
            <Trans>
              We ran out of posts from your follows. Here's the latest from{' '}
              {FEED_FALLBACK_FEED.profile_name ? (
                <TextLink
                  type="md-medium"
                  href={`/profile/${FEED_FALLBACK_FEED.profile_name || 'bsky.app'}/feed/${FEED_FALLBACK_FEEDNAME}`}
                  text={FEED_FALLBACK_FEED.title || 'Discover'}
                  style={pal.link}
                />
              ) : (
                FEED_FALLBACK_FEED.title || 'Discover'
              )}
              .
            </Trans>
          </Text>
        </View>
      ) : (
        <View style={{flex: 1}}>
          <Text type="md" style={pal.text}>
            <Trans>That's the end of posts from this feed.</Trans>
          </Text>
        </View>
      )}
    </View>
  )
}
